export default __webpack_public_path__ + "f118684dbec04a98069b4d9a2c0b577e.svg";